import * as React from "react";

import { P1 } from "./P1";
import { cn } from "../../ClassName";

interface Props {
  className?: string;
  children?: React.ReactNode;
  id?: string;
}

export function P1B(props: Props) {
  return (
    <P1 className={cn(`tw-font-bold`, props.className)} id={props.id}>
      {props.children}
    </P1>
  );
}
